import { render } from "./OptInV2.vue?vue&type=template&id=05ce7d7b&scoped=true&ts=true"
import script from "./OptInV2.ts?vue&type=script&lang=ts&external"
export * from "./OptInV2.ts?vue&type=script&lang=ts&external"

import "./Optinv2.scss?vue&type=style&index=0&id=05ce7d7b&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ce7d7b"]])

export default __exports__